export const formInputClass =
  "w-full border-b border-[rgba(201,162,75,0.3)] bg-transparent px-0 py-2.5 text-sm text-[#f2ede3] placeholder:text-[#6f6a5f] focus:border-[#c9a24b] focus:outline-none";

export const FormField = ({ label, error, children, testId }) => (
  <div>
    <label className="block text-xs font-semibold uppercase tracking-[0.15em] text-[#a09a8c]">
      {label}
    </label>
    <div className="mt-2">{children}</div>
    {error && (
      <p data-testid={testId ? `${testId}-error` : undefined} className="mt-1.5 text-xs text-[#e08a6b]">
        {error}
      </p>
    )}
  </div>
);
